import { Tabs } from 'antd';
import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { PERMISSIONS_KEY, ROUTES, TABS } from '../../../../../common/constants';
import { filterTabsByPermissions } from '../../../../../common/utils';

const TAB_ROUTES = {
  [TABS?.SUGGESTED_TOY?.key]: ROUTES?.SUGGESTED_TOY,
  [TABS?.CHANGE_ADDRESS?.key]: ROUTES?.CHANGE_ADDRESS,
  [TABS?.REPORT_DAMAGE?.key]: ROUTES?.REPORT_DAMAGE,
  [TABS?.ENCASHMENT?.key]: ROUTES?.ENCASHMENT,
  [TABS?.REVIEW?.key]: ROUTES?.REVIEW,
};

const getActiveTabKey = (pathname) =>
  Object?.keys(TAB_ROUTES)?.find((key) =>
    pathname?.includes(TAB_ROUTES?.[key]),
  ) ?? TABS?.SUGGESTED_TOY?.key;

const EndUserTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const {
    state: { permissions },
  } = useContext(AppContext);

  const tabList = [
    {
      key: TABS?.SUGGESTED_TOY?.key,
      label: TABS?.SUGGESTED_TOY?.label,
      children,
      permissionKey: PERMISSIONS_KEY?.REQUESTS_END_USER_CHANGE_ADDRESS,
    },
    {
      key: TABS?.CHANGE_ADDRESS?.key,
      label: TABS?.CHANGE_ADDRESS?.label,
      children,
      permissionKey: PERMISSIONS_KEY?.REQUESTS_END_USER_CHANGE_ADDRESS,
    },
    {
      key: TABS?.REPORT_DAMAGE?.key,
      label: TABS?.REPORT_DAMAGE?.label,
      children,
      permissionKey: PERMISSIONS_KEY?.REQUESTS_END_USER_REPORT_DAMAGE,
    },
    {
      key: TABS?.ENCASHMENT?.key,
      label: TABS?.ENCASHMENT?.label,
      children,
      permissionKey: PERMISSIONS_KEY?.REQUESTS_END_USER_ENCASHMENT,
    },
  ];

  const filteredTabs = [
    ...filterTabsByPermissions(tabList, permissions),
    {
      key: TABS?.REVIEW?.key,
      label: TABS?.REVIEW?.label,
      children,
    },
  ];

  const onTabChange = (key) => {
    const route = TAB_ROUTES?.[key];
    if (route) {
      history?.push(`${ROUTES?.REQUESTS}${ROUTES?.END_USER}${route}`);
    }
  };

  return (
    <div className="card-container">
      <Tabs
        activeKey={getActiveTabKey(location?.pathname)}
        type="card"
        className="full-width"
        onChange={(key) => onTabChange(key)}
        items={filteredTabs}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default EndUserTabs;
